import { Injectable, OnInit } from "@angular/core";
import * as moment from "moment";


@Injectable()
export class AgroDateUtil implements OnInit {


    ngOnInit(): void {

    }
    /**
     * Function responsável por recuperar o idioma do navegador
     */
    private capturaLocale() {
         if(navigator.language) {
            return navigator.language;
        }
        return "pt-BR";
    };

    
    /**
     * https://momentjs.com/docs/#/i18n/
     */

    formatDateISOToString(strDate: string){
        let dataMoment = moment(strDate);
        dataMoment.locale(this.capturaLocale());
        return dataMoment.format('L')
        
    }
    formatDateTimeISOToString(strDate: string){
        let dataMoment = moment(strDate);
        dataMoment.locale(this.capturaLocale());
        return dataMoment.format('L') + ' ' + dataMoment.format('LTS');
    }

    formatDateTimeISOToTimeString(strDate) {
        var dataMoment = moment(strDate);
        dataMoment.locale(this.capturaLocale());
        return dataMoment.format('LTS');
    }
}